import React from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import {
  format,
  parse,
  startOfWeek,
  getDay,
  startOfToday,
  isSameMonth,
} from "date-fns";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomEvent from "./Events";
import { Box, darken, Typography, useTheme } from "@mui/material";
import ContractEvent from "./ContractEvent";
import MeetingsEvent from "./MeetingsEvent";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 0 }),
  getDay,
  locales,
});

const CalendarComponent = ({
  data,
  onSelectEvent,
  title,
  dataType = "lead_base",
}) => {
  const events = data || [];
  const theme = useTheme();

  const eventStyleGetter = (event) => {
    const backgroundColor = event?.colorCode || theme?.palette?.primary?.main;
    const borderColor = event?.colorCode 
      ? darken(event.colorCode, 0.2) 
      : theme?.palette?.primary?.main;

    let style = {
      borderRadius: "8px",
      color: "#000",
      fontWeight: 500,
      fontSize: "0.8rem",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      backgroundColor: backgroundColor,
      border: `2px solid ${borderColor}`,
    };

    return {
      className: "custom-event",
      style: style,
      title: "",
    };
  };

  const CustomToolbar = (toolbar) => {
    const goToBack = () => toolbar.onNavigate("PREV");
    const goToNext = () => toolbar.onNavigate("NEXT");
    const goToToday = () => toolbar.onNavigate("TODAY");
    const label = format(toolbar.date, "MMMM yyyy");
    const today = startOfToday();
    const isCurrentMonth = isSameMonth(toolbar.date, today);

    return (
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        bgcolor={"primary.moonGlow"}
      >
        <Typography variant="h5" fontWeight={600} color={"secondary.light"}>
          {title} {label}
        </Typography>
        <Box display="flex" gap={1}>
          {!isCurrentMonth && <button onClick={goToToday}>Current</button>}
          <button onClick={goToBack}>◀</button>
          <button onClick={goToNext}>▶</button>
        </Box>
      </Box>
    );
  };

  return (
    <Box
      height={"80vh"}
      border={"1px solid black"}
      borderColor={"primary.main"}
    >
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        views={["month"]}
        defaultView="month"
        tooltipAccessor={() => null}
        popup={true}
        selectable={false}
        onSelectEvent={onSelectEvent}
        draggableAccessor={() => false}
        resizable={false}
        style={{
          height: "100%",
          backgroundColor: "#f9fafb",
          borderRadius: "12px",
        }}
        eventPropGetter={eventStyleGetter}
        components={{
          event: dataType === "lead_base" ? CustomEvent : dataType === "meeting" ? MeetingsEvent : ContractEvent,
          toolbar: CustomToolbar,
        }}
      />
    </Box>
  );
};

export default CalendarComponent;
